module.exports = __webpack_public_path__ + "static/img/noaddress.eb44c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noaddress.png
// module id = D7jI
// module chunks = 1